import { render, staticRenderFns } from "./PriceDemo.vue?vue&type=template&id=fc3f9fee&scoped=true"
import script from "./PriceDemo.vue?vue&type=script&lang=js"
export * from "./PriceDemo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PriceDemo.vue?vue&type=style&index=1&id=fc3f9fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3f9fee",
  null
  
)

export default component.exports